import React from 'react';
import { Outlet, Route, Routes } from 'react-router';
import App from 'views/App';
import Resumo from 'views/Resumo';
import Configurações from 'views/Configurações';
import Locais from 'views/Locais';
import LocaisGerar from 'views/Locais/Gerar';
import LocaisEnderecos from 'views/Locais/Enderecos';
import LocaisEnderecosGerar from 'views/Locais/Enderecos/Gerar';
import LocaisEnderecosTransferencia from 'views/Locais/Enderecos/Transferencia';
import Estoque from 'views/Estoque';
import EstoqueTransferencia from 'views/Estoque/Transferencia';
import Armazenagem from 'views/Armazenagem';
import ArmazenagemDetalhes from 'views/Armazenagem/Detalhes';
import ArmazenagemConferencia from 'views/Armazenagem/Conferencia';
import ArmazenagemArmazenar from 'views/Armazenagem/Armazenagem';
import Expedicoes from 'views/Expedicoes';
import ExpedicoesDetalhes from 'views/Expedicoes/Detalhes';
import ExpedicoesSeparacao from 'views/Expedicoes/Separacao';
import ExpedicoesEmbalagem from 'views/Expedicoes/Embalagem';
import ExpedicoesEmbalagemEdit from 'views/Expedicoes/Embalagem/Edit';
import ExpedicoesEmbalagemEtiqueta from 'views/Expedicoes/Embalagem/Etiqueta';
import ExpedicoesVolume from 'views/Expedicoes/Volume';
// import ExpedicoesLiberacao from 'views/Expedicoes/Liberacao';
//RELATÓRIOS
import Relatórios from 'views/Relatórios';
import RelatóriosFiltros from 'views/Relatórios/Filtros';

const RoutesTree = () => (
  <Routes>
    <Route path="" element={<App />} />
    <Route path="Resumo" element={<Resumo />} />
    <Route path="Configuracoes" element={<Configurações />} />
    <Route path="Estoque" element={<Outlet />}>
      <Route path=":hash?" element={<Estoque />} />
      <Route path="Transferencia" element={<EstoqueTransferencia />} />
    </Route>
    <Route path="Armazenagem" element={<Outlet />}>
      <Route path="" element={<Armazenagem />} />
      <Route path=":hash" element={<ArmazenagemArmazenar />} />
      <Route path="Detalhes/:id" element={<ArmazenagemDetalhes />} />
      <Route path="Conferencia/:hash?" element={<ArmazenagemConferencia />} />
    </Route>
    <Route path="Locais" element={<Outlet />}>
      <Route path="" element={<Locais />} />
      <Route path="Gerar/:hash?" element={<LocaisGerar />} />
      <Route path="Enderecos" element={<Outlet />}>
        <Route path=":hash" element={<LocaisEnderecos />} />
        <Route
          path="Transferencia"
          element={<LocaisEnderecosTransferencia />}
        />
        <Route path="Gerar/:hash" element={<LocaisEnderecosGerar />} />
      </Route>
    </Route>
    <Route path="Expedicoes" element={<Outlet />}>
      <Route path="" element={<Expedicoes />} />
      <Route path="Detalhes/:id" element={<ExpedicoesDetalhes />} />
      <Route path="Separacao/:hash?" element={<ExpedicoesSeparacao />} />
      <Route path="Embalagem" element={<Outlet />}>
        <Route path=":hash?" element={<ExpedicoesEmbalagem />} />
        <Route path="Edit/:hash" element={<ExpedicoesEmbalagemEdit />} />
        <Route
          path="Etiqueta/:hash"
          element={<ExpedicoesEmbalagemEtiqueta />}
        />
      </Route>
      <Route path="Volume/:hash?" element={<ExpedicoesVolume />} />
      {/* <Route path="Liberacao/:id" element={<ExpedicoesLiberacao />} /> */}
    </Route>
    <Route path="Relatorios" element={<Outlet />}>
      <Route path="" element={<Relatórios />} />
      <Route path="Filtros" element={<RelatóriosFiltros />} />
    </Route>
  </Routes>
);

export default RoutesTree;
